<template>
    <GuestLayout>
        <div style="width: 400px">
            <SendEmailCodeCard v-if="step === 'send-code'" :email="email" @code-sent="codeSent"/>
            <CheckEmailCodeCard
                v-else-if="step === 'check-code'"
                :email="email"
                :code="code"
                @code-checked="codeChecked"
                @back="step = 'send-code'"
            />
            <CreateUserCard
                v-else-if="step === 'create-user'"
                :email="email"
                :code="code"
                @user-created="userCreated"
                @back="step = 'check-code'"
            />
        </div>
    </GuestLayout>
</template>

<script>
import GuestLayout from "../../../layouts/GuestLayout.vue";
import SendEmailCodeCard from "./cards/SendEmailCodeCard.vue";
import CheckEmailCodeCard from "./cards/CheckEmailCodeCard.vue";
import CreateUserCard from "./cards/CreateUserCard.vue";
import { generateUrl } from "../../../../utils";

export default {
    name: "RegistrationPage",
    components: {
        GuestLayout,
        SendEmailCodeCard,
        CheckEmailCodeCard,
        CreateUserCard,
    },
    data() {
        return {
            step: 'send-code',
            email: '',
            code: '',
        }
    },
    methods: {
        codeSent(email) {
            this.email = email;
            this.step = 'check-code';
        },
        codeChecked(code) {
            this.code = code;
            this.step = 'create-user';
        },
        userCreated() {
            window.location.replace(generateUrl('app/home'));
        },
    },
}
</script>
